/* eslint-disable no-param-reassign */
/* eslint-disable no-extend-native */
const applyNativePolyfills = () => {
  if (typeof (Promise as any).allSettled !== 'function') {
    // @ts-expect-error This does not exist outside of polyfill which this is doing
    Promise.allSettled = function (promises: any[]) {
      return Promise.all(
        promises.map(promise =>
          Promise.resolve(promise).then(
            value => ({
              status: 'fulfilled',
              value,
            }),
            reason => ({
              status: 'rejected',
              reason,
            })
          )
        )
      );
    };
  }
};

export default function applyPolyfills() {
  applyNativePolyfills();
}
